import { createSlice } from "@reduxjs/toolkit";
import {
  CONST_INTRESTED_IN_PRIORITY_LIST,
  CONST_LOOKING_FOR_LIST,
  CONST_MP_CERTIFICATION_LIST,
  CONST_TYPEFORM_TYPES,
} from "../../../constants";
import { getLast100Years } from "../../../services/utils/date-and-time.utils";

const last100YearArray = getLast100Years();

const defaultValues = {
  data: null,
  loading: null,
  success: null,
  error: null,
};

interface ListInterface {
  data: Array<any> | null;
  loading: boolean | null;
  success: boolean | null;
  error: any;
}

interface InitialState {
  titles: ListInterface;
  industries: ListInterface;
  categories: ListInterface;
  opportunity_categories: ListInterface;
  timezones: ListInterface;
  no_of_emps: ListInterface;
  qualify_question_types: ListInterface;
  topics: ListInterface;
  lookingFor: ListInterface;
  intrestedInPriority: ListInterface;
  countries: ListInterface;
  states: ListInterface;
  mp_categories: ListInterface;
  mp_year: ListInterface;
  mp_certifications: ListInterface;
}

const initialState: InitialState = {
  titles: defaultValues,
  industries: defaultValues,
  categories: defaultValues,
  opportunity_categories: defaultValues,
  timezones: defaultValues,
  no_of_emps: defaultValues,
  topics: defaultValues,
  countries: defaultValues,
  states: defaultValues,
  mp_categories: defaultValues,
  mp_year: {
    data: last100YearArray,
    loading: null,
    success: null,
    error: null,
  },
  mp_certifications: {
    data: CONST_MP_CERTIFICATION_LIST,
    loading: null,
    success: null,
    error: null,
  },
  qualify_question_types: {
    data: CONST_TYPEFORM_TYPES,
    loading: null,
    success: null,
    error: null,
  },
  lookingFor: {
    data: CONST_LOOKING_FOR_LIST,
    loading: null,
    success: null,
    error: null,
  },
  intrestedInPriority: {
    data: CONST_INTRESTED_IN_PRIORITY_LIST,
    loading: null,
    success: null,
    error: null,
  },
};

const lists = createSlice({
  name: "lists",
  initialState,
  reducers: {
    setListLoading: (state, action) => {
      return {
        ...state,
        [action.payload.list]: {
          ...state[action.payload.list],
          loading: action.payload.loading,
        },
      };
    },
    setListData: (state, action) => {
      return {
        ...state,
        [action.payload.list]: {
          ...state[action.payload.list],
          data: action.payload.data,
        },
      };
    },
    setListSuccess: (state, action) => {
      return {
        ...state,
        [action.payload.list]: {
          ...state[action.payload.list],
          success: action.payload.success,
        },
      };
    },
    setListError: (state, action) => {
      return {
        ...state,
        [action.payload.list]: {
          ...state[action.payload.list],
          error: action.payload.error,
        },
      };
    },
  },
});

export const { setListData, setListError, setListLoading, setListSuccess } =
  lists.actions;

export default lists.reducer;
